
import axios from 'axios'
import $ from 'jquery'
import Choices from '@/components/Subjects/Choices'
import Judgement from '@/components/Subjects/Judgement'
import SortChoices from '@/components/Subjects/SortChoices'
import ShortAnswer from '@/components/Subjects/ShortAnswer'
import MultipleChoices from '@/components/Subjects/MultipleChoices'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Rater from 'vux/src/components/rater/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Card from 'vux/src/components/card/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Loading from 'vux/src/components/loading/index.vue'
import FormPreview from 'vux/src/components/form-preview/index.vue'

import XInput from 'vux/src/components/x-input/index'
import {fetch, promptMessage} from '@/api/dataHandling'
import {urlConfig} from '@/api/urlConfig'
import {getken} from '@/api/getToken'
import {getUrlParam} from '@/utils/urlUtil'
import Datetime from 'vux/src/components/datetime/index'

/**
*  字段说明：
*  examName 名称
*  examType 1在线考试，分值在每题上，是否正确  2 在线问卷 无分数、无测试结果 3 在线测试，分数在每个答案上，后台计算分值不一样
*  canAnwser 是否可以继续答题，后台控制
*  subjects 试题信息
*  personExams 答题信息
* personInfoId 个人基本信息id
*/
export default {
name: 'startExam',
directives: {
TransferDom
},
components: {
XTextarea, Rater, Checker, CheckerItem, Icon, Datetime, XInput, Choices, Group, Cell, XHeader, Grid, GridItem, Divider, Card, XButton, XDialog, Judgement, Loading, MultipleChoices, FormPreview, ShortAnswer, SortChoices
},
data () {
return {
url:'',
data3: 3,
loadingShow: false,
show: false,
modules: {},
currentModule: {},
currentModuleIndex: 0,
queryParam: {
examinationId: undefined
},
examName: undefined,
attention: '',
end: '',
personInfoId: '',
personExams: {},
canAnwser: '',
examType: '',
personInfo: {},
score: 0,
evalLevel: '',
eval: '',
suggest: '',
remark: '',
username: '',
commonData: '',
personModule: [],
depts: [],
canSubmit: false
}
},
created () {
this.loadingShow = true
getken(this.startData)
},
mounted () {
let _this = this
this.$nextTick(function () {
$('.inputClick').on('click', function () {
if (_this.lookIf) {
$(this).find('input, .textarea').focus()
}
})
})
},
methods: {
startExam: function () {

if (!this.personInfoId) { // 未获取到个人基本信息，不加载页面
return
}
this.queryParam.examinationId = getUrlParam('id')
let bizId = window.localStorage.getItem('bizId')
fetch('post', urlConfig.examSubjectGet, {
examinationId: this.queryParam.examinationId,
personInfoId: this.personInfoId,
bizId: bizId
}).then(resp => {
const {examName, modules, personExams, canAnwser, examType, attention, remark, end} = resp
this.examName = examName
this.canAnwser = canAnwser
this.examType = examType
this.attention = attention
this.modules = modules
this.remark = remark
this.end = end
if (this.modules) {
this.currentModule = modules[0]
for (let i = 0; i < this.currentModule.subjects.length; i++) {
if (this.currentModule.subjects[i].choices) {
for (let j = 0; j < this.currentModule.subjects[i].choices.options.length; j++) {
this.currentModule.subjects[i].choices.options[j]['inputIndex'] = 2
this.currentModule.subjects[i].choices.options[j]['inputVal'] = ''
}
}

/*    if(this.currentModule.subjects[i].subjectModel =='1'){
if(this.currentModule.subjects[i].anwser){
/!*this.currentModule.subjects[i].rateruserAnswerthis.currentModule.subjects[i].anwser*!/
}else{
this.currentModule.subjects[i].rateruserAnswer=0;
}
} */
}
}
if (this.examType === '3' && this.canAnwser === 1) {
this.getPersonInfo(this.personInfoId)
}
this.setPersonExams(personExams)
this.loadingShow = false
}).catch((e) => {
console.log(e)
this.loadingShow = false
})
},
next: function () {
let prom = this.vaild()
if (prom && prom.flag) {
promptMessage('提醒', prom.subjectName + '为必填！')
$('body ,html').scrollTop($('#attention' + (prom.subIndex - 1)).position().top - 50)
return
}
if (prom && prom.inputFlag) {
promptMessage('提醒', prom.subjectName + '补充内容为必填！')
$('body ,html').scrollTop($('#attention' + (prom.subIndex - 1)).position().top - 50)
return
}
for (let i = 0; i < this.modules.length; i++) {
if (this.modules[i].id === this.currentModule.id) {
if (i === this.modules.length - 1) {
promptMessage('已经是最后一题了!')
break
}
this.currentModule = this.modules[++i]
this.currentModuleIndex = i
this.setScorll()
break
}
}
},
pre: function () {
for (let i = 0; i < this.modules.length; i++) {
if (this.modules[i].id === this.currentModule.id) {
if (i === 0) {
promptMessage('已经是第一题了!')
break
}
this.currentModule = this.modules[--i]
this.currentModuleIndex = i
break
}
}
},
setPersonExams (personExams) {
if (personExams.length > 0) {
this.personExams = personExams
const {score, evalLevel, suggest, modules} = personExams[0]
this.score = score
this.evalLevel = evalLevel
this.eval = personExams[0].eval
this.suggest = suggest
this.personModule = modules
}
},
subCommit () {
this.$nextTick(() => {
let prom = this.vaild()
console.log(prom, prom.inputFlag)
if (prom && prom.flag) {
promptMessage('提醒', prom.subjectName + '必填！')
$('body ,html').scrollTop($('#attention' + (prom.subIndex - 1)).position().top - 50)
return
}
if (prom && prom.inputFlag) {
promptMessage('提醒', prom.subjectName + '补充内容为必填！')
$('body ,html').scrollTop($('#attention' + (prom.subIndex - 1)).position().top - 50)

/* this.emptIndex = prom.subIndex; */
return
}
if (this.queryParam.examinationId === '1456104630148509697') {
if (!this.commonData) {
promptMessage('提醒', '请选择所就诊科室！')
$('body ,html').scrollTop($('#attention0').position().top - 50)
return
}
}
this.loadingShow = true
let moduleJson = []

for (let i = 0; i < this.modules.length; i++) {
let moduleTemp = {}
moduleTemp.examinationModuleId = this.modules[i].id

for (let j = 0; j < this.modules[i].subjects.length; j++) {
let temp = {}
temp.subjectId = this.modules[i].subjects[j].subjectId
temp.anwser = this.modules[i].subjects[j].userAnswer

temp.userInput = JSON.stringify(this.modules[i].subjects[j].userInput)
if (!moduleTemp.anwsers) {
moduleTemp.anwsers = []
}
moduleTemp.anwsers.push(temp)
}
moduleJson.push(moduleTemp)
}
if (moduleJson) {
let paramId = window.localStorage.getItem('paramId')
if (!paramId) {
paramId = ''
}
let bizId = window.localStorage.getItem('bizId')
fetch('post', urlConfig.examSubjectSave, {bizId: bizId, commonData: this.commonData ? this.commonData : paramId, examType: this.examType, userName: this.username, examinationId: this.queryParam.examinationId, personInfoId: this.personInfoId, modules: moduleJson})
.then(resp => {
this.canAnwser = 2
this.loadingShow = false
this.setPersonExams(resp.personExams)
}).catch(() => {
this.loadingShow = false
})
}
})
},
getPersonInfo (personInfoId) {
fetch('get', urlConfig.queryPersonInfo + '?personInfoId=' + personInfoId).then(response => {
this.personInfo = response

}).catch(() => {})
},
getDepts () {
fetch('post', urlConfig.getrespdepturl + 'crm_exam_outhos_dept').then(response => {
this.depts = response
}).catch(() => {})
},
getPersonInfoId (openId) {
let hosCode = window.localStorage.getItem('hosCode')
axios.post(urlConfig.getWxBasicInfoByOpenId + '?openid=' + openId + '&hosCode=' + hosCode).then(res => {

let resultCode = res.data.resultCode


if (resultCode === 'error') {
this.toReg(hosCode)
} else {
axios.get(urlConfig.GetSfzh + '?openid=' + openId).then(response => {

const {resultCode} = response.data
if (resultCode === 'success') {
const {sfzh} = response.data.data

if (sfzh) {
fetch('post', urlConfig.GetPersonInfoId + '?sfzh=' + sfzh).then(response => {
this.personInfoId = response.personInfoId
this.startExam() 
}).catch(() => {
})
}
} else {
promptMessage('请先在公众号我的服务注册个人信息!')
}
}).catch(() => {
})
}
}).catch(error => {
console.log(error)
})
},
getGrape (item) {
this.$nextTick(function () {
for (let i = 0; i < item.choices.options.length; i++) {
if (item.rateruserAnswer == item.choices.options[i].score) {
item['userAnswer'] = item.choices.options[i].id
}
if (item.choices.options.length == 5) {
item['rateruserAnswerTxt'] = ''

if (item.rateruserAnswer == 5) {
item['rateruserAnswerTxt'] = '非常满意 '
} else if (item.rateruserAnswer == 4) {
item['rateruserAnswerTxt'] = '满意 '
} else if (item.rateruserAnswer == 3) {
item['rateruserAnswerTxt'] = '基本满意 '
} else if (item.rateruserAnswer == 2) {
item['rateruserAnswerTxt'] = '不满意 '
} else if (item.rateruserAnswer == 1) {
item['rateruserAnswerTxt'] = '非常不满意 '
}
console.log(item['rateruserAnswerTxt'], 234324234, item.rateruserAnswer)
}
}
this.$forceUpdate()
})
},
vaild () {
let prom = {}
for (let j = 0; j < this.currentModule.subjects.length; j++) {
/*      prom.inputIndex = ''; */
if (this.currentModule.subjects[j].subjectModel == '1') {
console.log(this.currentModule.subjects[j].optionInput)
if (this.currentModule.subjects[j].optionInput) {
this.currentModule.subjects[j].userInput = [{
optionInput: this.currentModule.subjects[j].optionInput,
optionId: this.currentModule.subjects[j].userAnswer
}]
}
}
if (this.currentModule.subjects[j].subjectMust === '1' && !this.currentModule.subjects[j].userAnswer) {
prom.subjectName = this.currentModule.subjects[j].subjectName
prom.flag = true
prom.subIndex = j + 1
break
}
if (this.currentModule.subjects[j].userAnswer && this.currentModule.subjects[j].type !== 4) {
prom.subIndex = j + 1
prom.subjectName = this.currentModule.subjects[j].subjectName


let userInput = this.currentModule.subjects[j].userInput
let options = this.currentModule.subjects[j].choices.options
let anwser = this.currentModule.subjects[j].userAnswer

if (anwser && anwser.toString().indexOf(',') > -1) {
anwser = this.currentModule.subjects[j].userAnswer.split(',')
}
if (this.currentModule.subjects[j].subjectModel == '1') {
anwser = this.currentModule.subjects[j].userAnswer.split(',')
}

for (let f = 0; f < anwser.length; f++) {
let uflag = false

let op = this.getOptions(options, anwser[f])
if (op && op.inputMust === '1') {
for (let g = 0; g < userInput.length; g++) {

console.log(userInput[g].optionId, anwser[f], userInput[g].optionInput)
if (userInput[g].optionId === anwser[f] && userInput[g].optionInput) {
uflag = true
break
}
}
if (!uflag) {
prom.inputFlag = true
break
}
}
}

if (prom && prom.inputFlag) {
break
}
}
}
/*    console.log(this.currentModule.subjects) */
return prom
},
getOptions (options, anwser) {
let op
for (let k = 0; k < options.length; k++) {
if (anwser === options[k].id) {
op = options[k]
break
}
}
return op
},
toReg (hosCode) {
window.location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=Mzg3MDM0MzI2Mw==&scene=124#wechat_redirect'
},
getOpenId (code) {
let cutton = location.href.split('?')[0]
let hosCode = window.localStorage.getItem('hosCode')
axios.get(urlConfig.getweixinOpenid + code + '&hosCode=' + hosCode).then(response => {
const {data} = response
const {resultMsg, openid} = data
if (openid) {
window.localStorage.setItem('openid', openid)
this.getPersonInfoId(openid)
} else {
/* promptMessage(resultMsg) */
let parmasquery = '?bb=1'
for (let i in this.$route.query) {
if (i != 'code' && i != 'bb') {
parmasquery = parmasquery + '&' + i + '=' + this.$route.query[i]
}
}
window.location.href = cutton + parmasquery + '&time=' + ((new Date()).getTime())
}
})
},
getWechatCode () {
this.loadingShow = true
let _this = this

let hosCode = window.localStorage.getItem('hosCode')
if (!hosCode) {
promptMessage('提示','链接未带院区')
}

axios.get(urlConfig.getsigninfo + encodeURIComponent(window.location.href) + '&hosCode=' + hosCode).then(response => {

const {data} = response
const code = getUrlParam('code')
if (!_this.$route.query.code) {
if (code == null || code === '') {
window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + data.appId + '&redirect_uri=' + encodeURIComponent(location.href) + '&response_type=code&scope=snsapi_base&state=1#wechat_redirect'
}
} else {
_this.getOpenId(code)
}
})
},
setAutoShowBySelect (selectVal) {
console.log('subjectId=', selectVal.subjectId)
for (let i = 0; i < this.modules.length; i++) {
let subjects = this.modules[i].subjects
for (let k = 0; k < subjects.length; k++) {
console.log('subjects[k].refSubject=', subjects[k].refSubject)

if (selectVal.subjectId === subjects[k].refSubject) {
console.log(subjects[k].refSubjectOptions, ' ==', selectVal.userAnswer)
if (subjects[k].refSubjectOptions.indexOf(selectVal.userAnswer) > -1) {
this.$refs[subjects[k].id][0].$el.style.display = 'block'
subjects[k].subjectMust = subjects[k].copySubjectMust
if (subjects[k].choices && subjects[k].choices.options.length > 0) {
for (let kk = 0; kk < subjects[k].choices.options.length; kk++) {
subjects[k].choices.options[kk].inputMust = subjects[k].choices.options[kk].copyInputMust
}
}
} else {
this.$refs[subjects[k].id][0].$el.style.display = 'none'
subjects[k].subjectMust = '2'
if (subjects[k].choices && subjects[k].choices.options.length > 0) {
for (let kk = 0; kk < subjects[k].choices.options.length; kk++) {
subjects[k].choices.options[kk].inputMust = '2'
}
}
}
}
}
}
},
setScorll () {
this.$nextTick(() => {

window.scrollTo(0, 0)
})
},
startData () {
let _this = this
let hosCode = _this.$route.query.hosCode;
let paramId = _this.$route.query.paramId;
let bizId = _this.$route.query.bizId;
this.orgId = _this.$route.query.orgId;
window.localStorage.setItem('hosCode', hosCode);
window.localStorage.setItem('paramId', paramId);
window.localStorage.setItem('bizId', bizId);
this.getWechatCode();

this.getDepts()

}
}
}



// WEBPACK FOOTER //
// ./src/project/exam/startExam.vue